import orderBy from 'lodash/orderBy';

export const parseIndustries = data => {
  if (!Array.isArray(data)) {
    return data;
  }
  const industriesSorted = orderBy(data, 'name', 'asc');
  return industriesSorted.map(industry => ({
    ...industry,
    sectors: orderBy(industry.sectors, 'name', 'asc'),
  }));
};
